(function (angular) {
    'use strict';

    angular.module('app.benefit-info').config(['$stateProvider', '$urlRouterProvider', benefitInfoRoutes]);

    function benefitInfoRoutes($stateProvider, $urlRouterProvider) {
        $stateProvider.state('app.benefit-info', {
            url: '/benefit-info',
            templateUrl: '/app/site/benefit-info/benefit-info.template.html',
            controller: 'app.benefit-info.controller'
        });
    }
})(angular);
